import { GraphSeriesData, Joint, KinematicYAxis } from '@/models/reportV2.model';

import { themeColors } from '@/theme/colors';

import { createKinematicYAxis, toVariabilityData } from '.';

/**
 * Calculates the mean kinematic data for a given segment.
 *
 * @param data - The input data object.
 * @param segment - The segment for which to calculate the mean kinematic data.
 * @returns An object containing the mean kinematic data for each plane.
 */

export function getMeanKinematicData(
  data: any,
  segment: Joint,
): { [key: string]: { series: GraphSeriesData[]; yAxis: KinematicYAxis } } {
  const planes = ['Sagittal', 'Coronal', 'Transversal'];

  // Mapping of segment indices for different planes
  const indicesMap: { [key: string]: { [key: string]: number[] } } = {
    Sagittal: {
      Pelvis: [0, 1],
      Hip: [2, 3],
      Thigh: [4, 5],
      Knee: [6, 7],
      Calf: [8, 9],
      Ankle: [10, 11],
      Foot: [12, 13],
    },
    Coronal: {
      Pelvis: [0, 1],
      Hip: [2, 3],
      Thigh: [4, 5],
      Knee: [6, 7],
      Calf: [8, 9],
      Ankle: [10, 11],
      Foot: [12, 13],
    },
    Transversal: {
      Pelvis: [0, 1],
      Hip: [2, 3],
      Thigh: [4, 5],
      Knee: [6, 7],
      Calf: [8, 9],
      Ankle: [10, 11],
      Foot: [12, 13],
    },
  };

  const result: { [key: string]: { series: GraphSeriesData[]; yAxis: KinematicYAxis } } = {};

  // Iterate over each plane to extract kinematic data
  planes.forEach((plane) => {
    const indices = indicesMap[plane][segment];

    const dataKey = plane === 'Sagittal' ? 'kinematicData' : `kinematicData_${plane}`;

    const seriesDataLeft = toVariabilityData(data.reportId[dataKey][`col${indices[0]}`]);
    const seriesDataRight = toVariabilityData(data.reportId[dataKey][`col${indices[1]}`]);

    const seriesData = [
      {
        type: 'line',
        name: 'Left',
        data: seriesDataLeft,
        color: themeColors.colorLeft, // Define your colorLeft variable appropriately
      },
      {
        type: 'line',
        name: 'Right',
        data: seriesDataRight,
        color: themeColors.colorRight, // Define your colorRight variable appropriately
      },
    ];

    const yAxisData = createKinematicYAxis(seriesData);
    result[plane] = {
      series: seriesData,
      yAxis: yAxisData,
    };
  });
  return result;
}
